import '@/globals.css';

import { renderClientLayout } from '@/helpers';

document.addEventListener('DOMContentLoaded', () => {
  renderClientLayout();
});
